import { Link, useLocation } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { catalogPath, localizedPath } from "@/lib/url-slugs";
import logo from "@/assets/logo.png";

function isCourtsPath(pathname: string) {
  return pathname.endsWith("/courts") || pathname.endsWith("/laukumi");
}

const Footer = () => {
  const { t, lang } = useLanguage();
  const { pathname } = useLocation();
  const courtsOnly = isCourtsPath(pathname);

  if (courtsOnly) {
    return (
      <footer className="bg-green-dark text-primary-foreground mt-auto">
        <div className="container mx-auto px-4 py-6 text-center text-xs text-footer-muted">
          &copy; {new Date().getFullYear()} PADELCORNER.LV. {t("footer.rights")}
        </div>
      </footer>
    );
  }

  return (
    <footer className="bg-green-dark text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div>
            <Link to={`/${lang}`} className="inline-block mb-4 hover:opacity-80 transition-opacity">
              <img src={logo} alt="Padel Corner" className="h-10 w-auto brightness-0 invert" width={59} height={40} />
            </Link>
            <p className="text-sm text-primary-foreground/70">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-3">{t("footer.shop")}</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li><Link to={catalogPath(lang, "rackets")} className="hover:text-accent transition-colors">{t("nav.rackets")}</Link></li>
              <li><Link to={catalogPath(lang, "apparel")} className="hover:text-accent transition-colors">{t("nav.apparel")}</Link></li>
              <li><Link to={catalogPath(lang, "shoes")} className="hover:text-accent transition-colors">{t("nav.shoes")}</Link></li>
              <li><Link to={catalogPath(lang, "bags")} className="hover:text-accent transition-colors">{t("nav.bags")}</Link></li>
              <li><Link to={catalogPath(lang, "balls")} className="hover:text-accent transition-colors">{t("nav.balls")}</Link></li>
              <li><Link to={catalogPath(lang, "accessories")} className="hover:text-accent transition-colors">{t("nav.accessories")}</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-3">{t("footer.help")}</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li><Link to={localizedPath(lang, "faq")} className="hover:text-accent transition-colors">{t("footer.faq")}</Link></li>
              <li><Link to={localizedPath(lang, "contact")} className="hover:text-accent transition-colors">{t("footer.customer_service")}</Link></li>
              <li><Link to={localizedPath(lang, "shipping")} className="hover:text-accent transition-colors">{t("footer.shipping_returns")}</Link></li>
              <li><a href="mailto:info@padelcorner.lv" className="hover:text-accent transition-colors">info@padelcorner.lv</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-3">{t("footer.legal")}</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li><Link to={localizedPath(lang, "terms")} className="hover:text-accent transition-colors">Noteikumi un nosacījumi</Link></li>
              <li><Link to={localizedPath(lang, "privacy")} className="hover:text-accent transition-colors">Privātuma politika</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold mb-3">{t("footer.contacts")}</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/70">
              <li className="font-semibold text-primary-foreground/90">SIA 2MOVE</li>
              <li>Rīga, Latvija</li>
              <li><a href="tel:+37122588218" className="hover:text-accent transition-colors">+371 22588218</a></li>
              <li><a href="mailto:info@padelcorner.lv" className="hover:text-accent transition-colors">info@padelcorner.lv</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-foreground/10 mt-8 pt-6 text-center text-xs text-footer-muted">
          &copy; {new Date().getFullYear()} PADELCORNER.LV. {t("footer.rights")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
